import { render, staticRenderFns } from "./correct3.vue?vue&type=template&id=2a27aaed&scoped=true"
import script from "./correct3.vue?vue&type=script&lang=js"
export * from "./correct3.vue?vue&type=script&lang=js"
import style0 from "./correct3.vue?vue&type=style&index=0&id=2a27aaed&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a27aaed",
  null
  
)

export default component.exports